import { first, mergeMap } from 'rxjs/operators';
import { StartSignupComponent } from '../ui';
import { Component, OnInit, ViewChild } from '@angular/core';
import { NgForm } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { UserStreamsRequestModel } from '../model';
import { DigestService, StreamService, TenantService, UserService } from '../services';
import { MatDialog } from '@angular/material/dialog';
import * as _ from 'lodash';
import { RequestPasswordResetComponent } from './RequestPasswordReset.component';
@Component({
    selector: 'login-form',
    styles: [`
        div[fxLayout="column"] > div[fxFlex] {
            flex: 1 0 auto !important;
        }
        
        .hidden {
            display: none;
        }
        mat-card {
            padding-left: 35px;
            padding-right: 35px;
        }
    `],
    template: `
        <div fxLayout="column" fxLayoutAlign="center center">
            <form (ngSubmit)="process()" #loginForm="ngForm">
                <div fxFlex="noshrink" fxLayout="column" fxLayoutAlign="center center" style="width: 100%; padding-top: 20px;">
                    <spinner *ngIf="noTouching"></spinner>
                    <mat-card [ngClass]="{ 'hidden': noTouching }">
                        <mat-card-header><h2 style="text-align: center;">Sign in to {{workspace}}</h2></mat-card-header>    
                        <mat-card-content *ngIf="invalidLogin" style="text-align: center;">
                            <mat-error id="login.invalidMessage">Invalid username / password pair.</mat-error>
                        </mat-card-content>
                        <mat-card-content *ngIf="!user" style="text-align: center;">
                            <mat-form-field>
                                <input matInput
                                    id="login.username" 
                                    type="text" 
                                    placeholder="Email address" 
                                    name="username" 
                                    ngModel
                                    (ngModelChange)="invalidLogin = false"
                                    #emailAddressCtrl="ngModel"
                                    required>
                                <mat-error *ngIf="emailAddressCtrl.hasError('required')" id="login.emailRequiredMessage">Email Address is required.</mat-error>    
                            </mat-form-field>
                        </mat-card-content>
                        <mat-card-content *ngIf="!user" style="text-align: center;">
                            <mat-form-field>
                                <input matInput 
                                    id="login.password"
                                    type="password" 
                                    placeholder="Password" 
                                    name="password" 
                                    ngModel
                                    (ngModelChange)="invalidLogin = false"
                                    #passwordCtrl="ngModel"
                                    required>
                                <mat-error *ngIf="!invalidLogin && passwordCtrl.hasError('required')" id="login.passwordRequiredMessage">Password is required.</mat-error>
                            </mat-form-field>
                        </mat-card-content>
                        <mat-card-content *ngIf="!user" style="text-align: center;">
                            <button fxFlex style="width: 75%" mat-raised-button type="submit" color="primary" [disabled]="!loginForm.valid">Sign In</button>
                        </mat-card-content>
                        <mat-card-content *ngIf="!user" style="text-align: center;">
                            <div style="padding-top: 5px; padding-bottom: 8px;">
                                <mat-checkbox 
                                    id="stayLoggedIn"
                                    ngModel 
                                    name="stayLoggedIn">
                                    Remember Me
                                </mat-checkbox>
                            </div>
                        </mat-card-content>
                        <mat-card-content *ngIf="user" style="text-align: center;">
                            <registration-details [collectNames]="showNameControls"></registration-details>
                        </mat-card-content>
                        <mat-card-actions >
                            <span *ngIf="!user">Forgot Password? <button mat-button type="button" color="primary" (click)="startPasswordReset()">Reset it here</button></span>
                            <button *ngIf="user" mat-raised-button color="primary" type="submit" [disabled]="!loginForm.valid">Register</button>
                        </mat-card-actions>
                    </mat-card>
                </div>
            </form>
            <div *ngIf="!noTouching && !selfSignupAllowed" fxFlex="60" fxLayout="column" style="padding-top:20px;" fxLayoutAlign="center center">
                <div fxLayout="column">
                    <h3>Don't have an account on {{workspace}} yet?</h3>
                    <p>Contact the workspace administrator for an invitation</p>
                </div>
                <div fxLayoutAlign="center center"  style="padding-top: 15px;">
                    <img class="header-image" src="/images/attensa-logo-130.png" alt="Attensa">
                </div>
            </div>
            <div *ngIf="!noTouching && selfSignupAllowed && !user" fxFlex="60" fxLayout="column" fxLayoutAlign="center center">
                <div fxLayout="row">
                    <h5>Don't have an account on {{workspace}} yet?</h5>
                    <button mat-button (click)="startSignup()" color="primary">Create an account</button>
                </div>
                <div *ngIf="!noTouching && selfSignupAllowed && !user" fxFlex="60" fxLayout="column" efxLayoutAlign="center center">
                    <div fxLayoutAlign="center center">
                        <h5 style="margin-top: 5px; margin-bottom: 5px;">Trying to create a workspace?</h5>
                        <a href="/createSite"
                        style="text-decoration: underline; color: blue; padding-left: 10px;">Create a workspace here.</a>
                    </div>
                    <div fxLayoutAlign="center center"  style="padding-top: 15px;">
                        <img class="header-image" src="/images/attensa-logo-130.png" alt="Attensa">
                    </div>
                </div>
            </div>
    `
})
export class LoginComponent implements OnInit {
    invalidLogin: boolean;
    selfSignupAllowed: boolean;
    @ViewChild('loginForm', { static: true }) public loginForm: NgForm;
    noTouching: boolean;
    user: any;
    showNameControls: boolean = true;
    workspace: string;

    constructor(private digestService: DigestService,
                private userService: UserService,
                private streamService: StreamService,
                private tenantService: TenantService,
                private router: Router,
                private route: ActivatedRoute,
                private dialog: MatDialog){}

    startSignup = () => this.dialog.open(StartSignupComponent, { height: '285px' ,width: '600px'});

    complete = () => {
        if(this.route.snapshot.queryParams.originator) {
            this.router.navigateByUrl(this.route.snapshot.queryParams.originator);
        } else if (this.userService.isCurrentUserCatalogManager()) {
            this.router.navigate(['/settings/shared/catalogs']);
        } else {
            this.streamService.getUserStreams(new UserStreamsRequestModel(this.userService.getCurrentUser().id)).pipe(first())
            .subscribe(streams => streams.content.length ? this.router.navigate(['/']) : this.router.navigate(['/browse']));
        }
    };

    process = () => {
        if (this.user) {
            this.noTouching = true;
            this.user.firstName = this.loginForm.value.user.firstName;
            this.user.lastName = this.loginForm.value.user.lastName;
            this.user.password = this.loginForm.value.user.password;
            this.userService.activateUser(this.user)
            .pipe(
                first(),
                mergeMap(() => this.digestService.getDigestConfigurationsForUser(this.user.id))
            ).subscribe(() => this.complete());
        } else {
            this.noTouching = true;
            this.userService.signIn({ 
                username: this.loginForm.value.username, 
                password: this.loginForm.value.password, 
                stayLoggedIn: this.loginForm.value.stayLoggedIn 
            }).pipe(first()).subscribe(
                () => this.complete(),
                err => {
                    this.noTouching = false;
                    this.invalidLogin = true;
                }
            );
        }
    };

    startPasswordReset = () => this.dialog.open(RequestPasswordResetComponent, { height: '250px', width: '350px' });

    ngOnInit() {
        this.tenantService.getUnauthTenantInfo().pipe(first())
        .subscribe(tenant => {
            this.workspace = tenant.name;
            this.selfSignupAllowed = tenant.settings.selfSignupConfiguration;
            this.noTouching = false;
        });
        const start = this.route.snapshot.queryParams.start;
        if (start && start === 'passwordReset') {
            this.startPasswordReset();
        } else if (start && start === 'register') {
            this.startSignup();
        }
    }
}
